import { SessionService } from './../../../../services/global_services/session.service';
import { environment } from './../../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from "@angular/core"; 
import { DomSanitizer, Title } from "@angular/platform-browser"; 
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { Route, Router } from "@angular/router";
import { NgwWowService } from "ngx-wow";
import { DeviceDetectorService } from "ngx-device-detector";
import { DateHelpers } from "src/app/common/helpers";
import { CourseLevel } from "src/app/common/enums";
import { DatePipe } from "@angular/common";
import { TranslationService } from "src/app/services/translation.service";
import { TranslateService } from "@ngx-translate/core";
import { Languages } from "src/app/common/languages";
import { HttpClient, HttpHeaders } from "@angular/common/http";

declare var $: any;

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.css"],
})
export class LandingPageComponent implements OnInit, AfterViewInit {

  @ViewChild('contactUs', { static: false }) contactUs: ElementRef;

  baseUrl = environment.baseUrl;
  _currentUrl: string = '';

  public Quotes;
  public ActiveQuote;
  public Courses;
  public Blogs;
  private wowSubscription: Subscription;
  public PopularCoaches;

  private pipe = null;
  form: FormGroup;
  submitted: boolean = false;
  IsMobileView = false;
  IsWrapped: boolean = true;
  WrappedCoachId: number;
  languages = Languages;

  constructor( 
    private _sanitizer: DomSanitizer, 
    private formBuilder: FormBuilder,
    private toastService: ToastrService,
    private wowService: NgwWowService,
    public translate: TranslateService,
    private _translationService: TranslationService,
    private deviceService: DeviceDetectorService,
    private titleService: Title,
    private sessionService: SessionService,
    private route: Router,
    private http: HttpClient
  ) {
    this.titleService.setTitle("Build your career with coach you | Coach you ")
    translate.use(
      localStorage.getItem("lang") !== null ||
        localStorage.getItem("lang") !== null
        ? localStorage.getItem("lang")
        : "ar"
    );
    this._currentUrl = this.route.url;
  }

  ngAfterViewInit() {
    if (this._currentUrl == '/#contactUs') {
      setTimeout(() => {
        this.contactUs.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      }, 1000);
    }
  }

  ngOnInit() {
    this.wowService.init();
    // you can subscribe to WOW observable to react when an element is revealed
    this.wowSubscription = this.wowService.itemRevealed$.subscribe(
      (item: HTMLElement) => {
        // do whatever you want with revealed element
      }
    );

    if (location.href.indexOf("#") > -1) {
      let hashIndex = location.href.indexOf("#");
      if (location.href.slice(hashIndex) == "#contactUs") {
        $('html, body').animate({ scrollTop: $("#contactUs").offset().top + 1700 }, 'slow');
      }
    }

    this.getPopularCoaches();

    // this.coachesService.GetPopularCoaches().subscribe((response) => {
    //   response.result.forEach((coach) => {
    //     coach.languages = coach.languages.map(
    //       (item) =>
    //         this.languages.filter(
    //           (language) => language.id == item.language_id
    //         )[0]
    //     );
    //   });
    //   this.PopularCoaches = response.result;
    // });

    // populate quotes 
    // this.miscServices.GetUsersQuotes().subscribe((response) => {
    //   this.Quotes = response.result;
    //   this.ActiveQuote = this.Quotes[0];
    //   this._initializeQuotes();
    //   this._initializeBannerSlider();
    // });

    // populate courses
    // this.coursesService
    //   .GetCourses(null, null, { page: 0, rows: 4, totalCount: 4 })
    //   .subscribe((response) => {
    //     this.Courses = response.result;
    //     this._initializeCoursesSlider();
    //   });

    // populate blogs
    // this.blogsService.GetPinnedBlogs().subscribe((response) => {
    //   this.Blogs = response.result;
    // });



    // contact form
    this.form = this.formBuilder.group({
      contact_name: [""],
      contact_email: ["", [Validators.required]],
      contact_phoneNumber: [""],
      contact_message: ["", [Validators.required]],
      contact_subject: [""],
    });
  }



  getPopularCoaches() {
    this.http.post<any>(environment.baseUrl + "CoachRequest/search", { pageSize: 3, pageNumber: 1 }).subscribe(res => {
      if (res.errorCode == 0) {
        this.PopularCoaches = res.data.data;
      }
    })
    this.http.get<any>(environment.baseUrl + "Blog?PageSize=3&PageNumber=1", {
      headers: new HttpHeaders({ "Accept-Language": localStorage.getItem("lang") })
    }).subscribe(res => {
      this.Blogs = res.data.data;
    })
  }


  getImageUrl(url) {
    return url ? environment.baseUrl + "File/get" + url : "assets/img/noImageAvailable.png";
  }

  getBackgroundUrl(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  changeQuote(index) {
    this.ActiveQuote = this.Quotes[index];
  }

  DateOnly(date) {
    if (this.pipe === null) {
      this.pipe = new DatePipe("en-US"); // Use your own locale
    }
    const myFormattedDate = this.pipe.transform(new Date(date), "short");
    return myFormattedDate;
  }

  /**  contact form **/

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  async onContactSubmit() {
    this.submitted = true;


    if (this.form.invalid) return

    let req = new FormData();

    req.append("Email", this.form.get("contact_email").value);
    req.append("PhoneNumber", this.form.get("contact_phoneNumber").value);
    req.append("Message", this.form.get("contact_message").value);
    req.append("FullName", this.form.get("contact_name").value);
    req.append("Subject", this.form.get("contact_subject").value);
    req.append("ApplicationType", "1");

    this.http.post<any>(environment.baseUrl + "contactUs", req).subscribe(res => {
      if (res.errorCode == 0) {
        this.toastService.success("Success")
        this.form.reset();
        this.submitted = false;
      } else {
        console.log(res.error);
        this.toastService.error(res.error);
      }
    })
  }

  isArabic() {
    var lang = this._translationService.getLanguage();
    if (lang == "ar") return true;

    return false;
  }
  GetCourseLevelText(courseLevel) {
    let level = CourseLevel[courseLevel];
    return level.toString();
  }

  public TimeOnly(date) {
    let newDate;
    if (typeof date === "string") {
      newDate = date
        .replace(/-/g, "/")
        .replace(/T/g, " ")
        .substring(0, date.length - 4);
    }
    return DateHelpers.TimeFormatted(newDate ? new Date(newDate) : date);
  }

  public ShortendedDate(date) {
    date = new Date(date);
    return DateHelpers.FormatDateMonthShortented(date);
  }

  private _initializeCoursesSlider() {
    $(function () {
      //Course Carousel
      var Course = $(".Course .owl-carousel");
      Course.owlCarousel({
        loop: true,
        navText: ["", ""],
        margin: 20,
        nav: false,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          992: {
            items: 2,
          },
        },
      });

      //Course Carousel Next/Prev Custom Button
      $(".Course .navigation.next").on("click", function () {
        Course.trigger("next.owl.carousel");
      });
      $(".Course .navigation.prev").on("click", function () {
        Course.trigger("prev.owl.carousel");
      });

      $(".Course .owl-stage-outer").css({ height: "500px" });
    });
  }

  private _initializeQuotes() {
    $(function () {
      //Testimonials Carousel Next/Prev Button
      var testimonials = $(".testimonials .owl-carousel");
      testimonials.owlCarousel({
        loop: true,
        navText: ["", ""],
        margin: 20,
        nav: false,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          992: {
            items: 2,
          },
        },
      });

      //Testimonials Carousel Next/Prev Custom Button
      $(".testimonials .navigation.next").on("click", function () {
        testimonials.trigger("next.owl.carousel");
      });

      $(".testimonials .navigation.prev").on("click", function () {
        testimonials.trigger("prev.owl.carousel");
      });

      $(".testimonials .owl-stage-outer").css("height", "390px");
    });
  }

  private _initializeBannerSlider() {
    $('.home-slides').owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
      nav: true,
      responsiveClass: true,
      dots: false,
      autoplayHoverPause: true,
      mouseDrag: true,
      navText: [
        "<i class='icofont-bubble-left'></i>",
        "<i class='icofont-bubble-right'></i>"
      ],
    });
    $(".home-slides").on("translate.owl.carousel", function () {
      $(".main-banner h1").removeClass("animated fadeInUp").css("opacity", "0");
      $(".main-banner p").removeClass("animated zoomIn").css("opacity", "0");
      $(".main-banner .btn, .main-banner .video-btn").removeClass("animated fadeInDown").css("opacity", "0");
      $(".main-banner .startup-image").removeClass("animated zoomIn").css("opacity", "0");
    });
    $(".home-slides").on("translated.owl.carousel", function () {
      $(".main-banner h1").addClass("animated fadeInUp").css("opacity", "1");
      $(".main-banner p").addClass("animated zoomIn").css("opacity", "1");
      $(".main-banner .btn, .main-banner .video-btn").addClass("animated fadeInDown").css("opacity", "1");
      $(".main-banner .startup-image").addClass("animated zoomIn").css("opacity", "1");
    });
  }


  checkImageUrl(event, course = null) {
    // if (course) {
    //   console.log("TEST");
    //   event.srcElement.src =
    //   "https://coachyou.co/uploads/system_images/no_image_available.png";
    // } else {
    //   console.log("Error");
    //   event.srcElement.src =
    //     "https://coachyou.co/uploads/system_images/user.png";
    // }
  }

}
